<div class="tb-m-container">
    <div class="buttons-block">
        <ion-select size="6" [ngClass]="{'arrowcheck': !items?.length}" (ionChange)="onItemSelect($event)" [placeholder]="team">
            <ion-select-option *ngFor="let item of items; let i = index;" [value]="item">
                {{ item.name }}
            </ion-select-option>
        </ion-select>
        <div class="btn team" (click)="onClick.emit(toolbar.team)" [ngClass]="{ 'team-disabled': !disabled }"></div>
        <div class="btn tshirt" (click)="onClick.emit(toolbar.tshirt)" [ngClass]="{ 'tshirt-disabled': !disabled }">
        </div>
        <div class="btn field" (click)="onClick.emit(toolbar.field)" [ngClass]="{ 'field-disabled': !disabled }">
        </div>
        <ion-button shape="round" fill="clear"  (click)="onClick.emit(toolbar.share)"
            [ngClass]="{ 'share-disabled': !disabled }">
            <ion-icon  slot="icon-only" name="share" class="icon-block" color="dark"></ion-icon>
        </ion-button>
        <ion-button shape="round" fill="clear" (click)="onClick.emit(toolbar.settings)">
            <ion-icon slot="icon-only" name="settings" class="icon-block" color="dark">
            </ion-icon>
        </ion-button>
    </div>
</div>